import { Component, OnInit } from '@angular/core';
import { NavController, PopoverController, ModalController, ViewController, Platform,
  AlertController, NavParams, ActionSheetController, LoadingController } from 'ionic-angular';
import * as _ from 'lodash';
import { MeteorObservable } from 'meteor-rxjs';
import { Subscription, Observable, Subscriber } from 'rxjs';

import { Log, LogType, LogMessage, LogMessageType, Activity, Project } from 'api/models';
import { PictureService } from '../../services/picture';
import { LogMessages, Activities, Logs, Users } from 'api/collections';
import { ShowPictureComponent } from '../show-picture/show-picture';
import { ISDEV } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { AuthenticationService } from '../../services/congito';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'log-photos',
  templateUrl: 'log-photos.html'
})
export class LogPhotosPage implements OnInit {
public isDev = ISDEV;
  photoMessages: Array<LogMessage & { sentBy: string }>;
  logId: string;
  log: Log;
  logMessagesBatchCounter: number = 0;

  constructor(
    navParams: NavParams,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private platform: Platform,
    private viewCtrl: ViewController,
    private modelCtrl: ModalController,
    private pictureService: PictureService,
    private popoverCtrl: PopoverController,
    private actionSheetCtrl: ActionSheetController,
    private loadingCtrl: LoadingController,
    public httpService: HttpService,
    public authenticationService: AuthenticationService,
    private sharedService: SharedService,
  ) {
    this.logId = <string>navParams.get('logId');
  }

  ngOnInit() {
    if(this.isDev == true) { console.log('log photos page') }
    /*
    MeteorObservable.subscribe('logDetails', this.logId).subscribe(() => {
      MeteorObservable.autorun().subscribe(() => {
        if (this.logId) {
          this.log = Logs.collection.findOne(this.logId);
        }
      });
    });
    */

    this.httpService.MeteorSubscribe('logDetails', this.logId)
    .then(()=>this.httpService.privateLoopAction(true))
    .then(() => {
      MeteorObservable.autorun().subscribe(async () => {
        if (this.logId) {
          this.log = Logs.collection.findOne(this.logId);
          this.log.featuredImage=this.log.featuredImage?await this.authenticationService.imageConverter(this.log.featuredImage):this.log.featuredImage
        }
      });
    });

    /*
    MeteorObservable.subscribe('logPictureMessages', this.logId).subscribe(() => {
      MeteorObservable.autorun().subscribe(() => {
        this.photoMessages = this.findPhotos();
       if(this.isDev == true) {  console.log(this.photoMessages) }
      });
    });
    */

    this.httpService.MeteorSubscribe('logPictureMessages', this.logId)
    .then(()=>this.httpService.privateLoopAction(true))
      .then(() => {
        MeteorObservable.autorun().subscribe(async () => {
          this.photoMessages = await this.findPhotos();
          if(this.isDev == true) {  console.log(this.photoMessages) }
        });
      });
  }

  async findPhotos(): Promise<Array<LogMessage & {sentBy: string}>> {
    let messages= LogMessages.find({
      logId: this.logId,
      type: LogMessageType.PICTURE,
    }, {
      sort: { createdAt: -1 }
    }).fetch().map((message) => {
        return {
          ...message,
          sentBy: (Users.findOne(message.senderId) || {profile: {name: ''}}).profile.name,
        };
      });
    for(const i in messages){
      messages[i].content=messages[i].content?await this.authenticationService.imageConverter(messages[i].content):messages[i].content
    }

    return messages;
  }

  openPhoto(photoMessage) {
    const modal = this.modalCtrl.create(ShowPictureComponent, {
      logMessageId: photoMessage._id,
      pictureSrc: photoMessage.content,
    });

    modal.present();
  }

  showAttachments(): void {
    this.pictureService.getPicture(this.actionSheetCtrl)
      .then((blob: File) => {
        this.pictureService.upload(blob).then((picture) => {
          this.sendPictureMessage(blob);
        });
      });
  }

  sendPictureMessage(blob: File): void {
    let loading = this.loadingCtrl.create({
      content: 'Uploading image...',
      duration: 30*1000,
    });

    loading.present();

    this.pictureService.upload(blob).then((picture) => {
      /*
      MeteorObservable.call(
        'addLogMessage',
        LogMessageType.PICTURE,
        this.logId,
        picture.url
      ).subscribe(() => {
        loading.dismiss();
      }, (err) => {
        this.showError(err);
        loading.dismiss();
      });
      */
      this.httpService.MeteorCall(
        'addLogMessage',
        LogMessageType.PICTURE,
        this.logId,
        picture.url
      ).then(async () => {
        loading.dismiss();
        this.photoMessages.push({
          createdAt: new Date(),
          type: LogMessageType.PICTURE,
          content: await this.authenticationService.imageConverter(picture.url),
          logId: this.logId,
          senderId: this.authenticationService.MeteorUser()._id,
          sentBy: (this.authenticationService.MeteorUser() || {profile: {name: ''}}).profile.name,
        } as any)
      })
      .catch((err) => {
        this.showError(err);
        loading.dismiss();
      });
    });
  }

  setFeaturedImage(url, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.httpService.MeteorCall('setLogFeaturedImage', this.logId, "https://logit-test-test.s3.amazonaws.com/"+this.authenticationService.deconvertImage(url));
    Logs.update({_id: this.logId}, {$set: {
      featuredImage: "https://logit-test-test.s3.amazonaws.com/"+this.authenticationService.deconvertImage(url),
      lastModified: new Date(),
    }});
    this.log.featuredImage=url;
  }

  presentActionSheet(logMessage: LogMessage, event) {
    if (event) {
      event.stopPropagation();
    }
    const canMakeFeaturedImage = logMessage.content !== this.log.featuredImage;
    let actionSheet = this.actionSheetCtrl.create({
      title: '',
      buttons: _.compact([
        {
          text: 'Delete Image',
          role: 'destructive',
          icon: 'trash',
          handler: () => {
            /*
            MeteorObservable.call('removeLogMessage', logMessage._id).subscribe({
              next: () => {
                // this.viewCtrl.dismiss();
              },
            });
            */
            this.httpService.MeteorCall('removeLogMessage', logMessage._id)
              .then(() => {
                LogMessages.remove({_id:logMessage._id})
              })
              .catch(err => console.log('meteor call error:', err));
          }
        },
        canMakeFeaturedImage && {
          text: 'Make Featured Image',
          icon: 'star-outline',
          handler: () => {
            this.setFeaturedImage(logMessage.content);
          }
        }, {
          text: logMessage.captionText ? 'Edit Caption' : 'Add Caption',
          icon: 'create',
          handler: () => {
            this.showPhotoCaptionPrompt(logMessage, this.alertCtrl);
          }
        },{
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => {
          }
        }
      ]),
    });
    actionSheet.present();
  }
  showPhotoCaptionPrompt(logMessage: LogMessage, alertCtrl: AlertController) {
    const message = logMessage.captionText ? 'Edit photo caption' : 'Add a caption';
    let prompt = alertCtrl.create({
      title: 'Photo Caption',
      message: message,
      inputs: [
        {
          name: 'caption',
          placeholder: 'Caption...',
          value: logMessage.captionText,
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Save',
          handler: ({ caption }) => {
            this.httpService.MeteorCall('updateLogMessageCaptionText', logMessage._id, caption);
            LogMessages.update({_id: logMessage._id}, {$set: {captionText:caption}});
          }
        }
      ]
    });
    prompt.present();
  }

  showError(e: Error): void {
    if(this.isDev == true) { console.error(e) }

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/log-photos/log-photos.ts